/**
 * DAM Router
 * Main routing component for the DAM feature
 */

import React, { Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

// Lazy load components for code splitting
const DAMDashboard = React.lazy(() => import('./DAMDashboard'));
const Browse = React.lazy(() => import('./Browse'));
const AssetDetail = React.lazy(() => import('./AssetDetail'));
const Purge = React.lazy(() => import('./Purge'));

function LoadingSpinner() {
  return (
    <div className="flex items-center justify-center h-64">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
    </div>
  );
}

export default function DAMRouter() {
  return (
    <Suspense fallback={<LoadingSpinner />}>
      <Routes>
        <Route index element={<DAMDashboard />} />
        <Route path="/" element={<DAMDashboard />} />
        <Route path="/browse" element={<Browse />} />
        <Route path="/asset/*" element={<AssetDetail />} />
        <Route path="/purge" element={<Purge />} />
      </Routes>
    </Suspense>
  );
}
